import { render, staticRenderFns } from "./TwoColumnText.vue?vue&type=template&id=42d03355&scoped=true&"
import script from "./TwoColumnText.vue?vue&type=script&lang=js&"
export * from "./TwoColumnText.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnText.vue?vue&type=style&index=0&id=42d03355&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d03355",
  null
  
)

export default component.exports